/**
 * ModeSwitcher — footer chips on study pages for swapping between
 * Puzzle / Typing / Speaking. The current mode is hidden so users
 * always see two alternates.
 */
import type { ReactNode } from 'react';
import { GlassButton } from '@/components/GlassButton';
import { Icon, type IconName } from '@/components/Icon';
import type { StudyMode } from '@/lib/types';

interface Props {
  lessonId: string;
  current: StudyMode;
  /** Optional trailing slot (e.g. a RETRY button). */
  extra?: ReactNode;
}

const MODES: Array<{ key: StudyMode; label: string; icon: IconName }> = [
  { key: 'puzzle',   label: 'PUZZLE',   icon: 'puzzle' },
  { key: 'typing',   label: 'TYPING',   icon: 'typing' },
  { key: 'speaking', label: 'SPEAKING', icon: 'speaking' },
];

export function ModeSwitcher({ lessonId, current, extra }: Props): JSX.Element {
  return (
    <div className="flex flex-wrap gap-2 justify-center pt-2 text-xs font-arcade text-cream-500 tracking-widest">
      <span className="self-center mr-2">SWITCH</span>
      {MODES.filter((m) => m.key !== current).map((m) => (
        <GlassButton key={m.key} to={`/app/study/${m.key}/${lessonId}`} size="sm">
          <Icon name={m.icon} size="sm" />
          {m.label}
        </GlassButton>
      ))}
      {extra}
    </div>
  );
}
